module.exports = __webpack_public_path__ + "static/media/中级开发者.44f16cf2.png";